module.exports = __webpack_public_path__ + "img/nostromo 3.1f0425db.jpeg";